<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v1.0
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity.
    //    */
    //-->
    <v-row>
      <v-col class="green--text">
        <h4><strong>For John:</strong></h4>
        <h4>Get movie to work</h4>
        <h4>make animations start on scroll</h4>
        <h4>
          make recruit and lateral images drop when qualifications expansion is
          clicked on large only - see https://www.renopd.us/
        </h4>
        <h4>delete ToDO button from banner.vue</h4>
        <br />
        <h4>Barb's</h4>
        <h4 style="text-decoration: line-through">change copyright text</h4>

        <h4 style="text-decoration: line-through">
          look at mobile and tablet - IN progress
        </h4>
        <h4 style="text-decoration: line-through">
          Add md image to image-texts
        </h4>
        <h4 style="text-decoration: line-through">
          On small lateral pic not centered
        </h4>
        <h4 style="text-decoration: line-through">
          on small - wrong service/about text
        </h4>
        <h4 style="text-decoration: line-through">
          on medium no strt your application text
        </h4>
        <h4 style="text-decoration: line-through">make about text move</h4>
        <h4 style="text-decoration: line-through">
          figure out why button heights are not changing on mobile. inspector
          shows the desired height but it's not displaying that
        </h4>

        <br />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rename",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
